<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>展位详情</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row row-cols-lg-2 row-cols-md-2 row-cols-1">
		            <div class="col">
		                <div class="project-details-img-wrap">
		                    <div class="project-details-img mb-6" v-for="(item,index) in imgInfo" :key="index">
		                        <img :src="item | imgfilter" alt="Project Image">
		                    </div>
		                </div>
		            </div>
		            <div class="col sidebar-active">
		                <div class="project-wrapper-sticky">
		                    <div class="project-details-content mb-5 mb-md-8">
		                        <h5>{{productInfo.name}}</h5>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
import { 
	getBooth,
} from "@/api"
export default {
   data() {
		return { 
			bgImg: require('@/static/images/banner/banner-3.jpg'),
			imgInfo: [],
			productInfo: {},
			merchantInfo: {},
		}
	},
	created() {
		this.getBooth()
	},
	methods:{
		
		toMerchant(data) {
			let routeUrl3 = this.$router.resolve({
				path: '/merchantDetail/'+data.zk_id,
			  })
			  window.open(routeUrl3.href, '_blank')
		},
		
		// 获取展位详情
		async getBooth() {
		  const res = await getBooth({
			  id: this.$route.params.id
		  })
		 let data = res.data.boothInfo || {}
		 this.imgInfo = data.img_detail
		 console.log(this.imgInfo)
		 
		 if(data.tags) data.tags = data.tags.split(',') || []
		 this.productInfo = data
		},
		
		
	}
}
</script>

<style>
</style>
